import { render, staticRenderFns } from "./RiverRumble.vue?vue&type=template&id=7a20ebb9&scoped=true&"
import script from "./RiverRumble.vue?vue&type=script&lang=js&"
export * from "./RiverRumble.vue?vue&type=script&lang=js&"
import style0 from "./RiverRumble.vue?vue&type=style&index=0&id=7a20ebb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a20ebb9",
  null
  
)

export default component.exports